import React, { forwardRef } from 'react';

import type { GenderNullableParameter } from '@vlabs/api/luna-api/model';
import { GENDER_OPTIONS } from '@vlabs/api-bindings/src/constants';
import { Radio } from '@vlabs/uikit/components/controls/radio';

import type { PopoverWithButtonProps } from '@vlabs/monokit/shared/ui/popovers';
import { PopoverWithButton } from '@vlabs/monokit/shared/ui/popovers';

import { useEventListFilters } from '../../useEventListFilters';
import st from '../popovers.module.sass';

interface GenderOption {
  value: GenderNullableParameter;
  label: string;
}

const genderOptions = GENDER_OPTIONS.raw as GenderOption[];

function GenderFilterPopover(
  props: PopoverWithButtonProps,
  ref: React.ForwardedRef<HTMLDivElement>,
) {
  const { filters, updateFilters } = useEventListFilters();

  const selectedGender = filters.gender;

  return (
    <PopoverWithButton
      {...props}
      isButtonDisabled={selectedGender === undefined}
      onClickReset={() => updateFilters({ gender: undefined })}
      ref={ref}
    >
      <div className={st.RadioWrapper}>
        {genderOptions.map((option) => (
          <Radio
            checked={selectedGender === option.value}
            key={String(option.value)}
            label={option.label}
            onChange={() => updateFilters({ gender: option.value })}
          />
        ))}
      </div>
    </PopoverWithButton>
  );
}

const GenderFilterPopoverWithRef = forwardRef(GenderFilterPopover);
export { GenderFilterPopoverWithRef as GenderFilterPopover };
